import React, { useEffect, useState } from 'react';
import { findEmails, findUsers } from '../../../firebase';
import { UseAuthContext } from '../../../context/AuthContext';
import PicModal from './PicModal';

export default function Admin({ admin }) {
    const [msgConnect, setMsgConnect] = useState("");
    const [msgUser, setMsgUser] = useState("");
    const [msgEmails, setMsgEmails] = useState("");
    const { userList, setUserList, emails, setEmails } = UseAuthContext();
    const [users, setUsers] = useState([]);
    const [requests, setRequests] = useState([]);
    const [requestList, setRequestList] = useState([]);
    const [modalDetails, setModalDetails] = useState({ name: "", pic: "" });
    const [userForm, setUserForm] = useState({
        id: "",
        name: "",
        phone: "",
        type: ""
    });
    const [requestForm, setRequestForm] = useState({
        type: "",
        name: "",
        user: "",
        userId: "",
        to: "",
        from: ""
    })

    useEffect(() => {
        setUsers(userList);
        setRequests([].concat(...userList.map(u => u.request)));
        setRequestList([].concat(...userList.map(u => u.request)));
    }, [userList]);

    const getContacts = () => {
        setMsgEmails("Loading");
        findEmails().then(res => {
            if (res.length > 0) {
                setEmails(res);
                setMsgEmails("");
            } else {
                setMsgEmails("No data");
            }
        }).catch(e => {
            setMsgEmails("Error");
        })
    }

    const getUsers = () => {
        setMsgConnect("Loading");
        if (admin) {
            getContacts();
            findUsers().then(res => {
                setMsgConnect("");
                if (res.length > 0) {
                    setUserList(res);
                } else {
                    setMsgUser("No data");
                }

            }).catch(e => {
                setMsgConnect("Error");
            })
        } else {
            setMsgConnect("No access");
        }
    }

    const handleUserForm = (e) => {
        let name = e.target.name;
        let value = e.target.value.trim();
        setUserForm(pre => ({ ...pre, [name]: value }));
    }
    const resetUserForm = () => {
        setUserForm({
            id: "",
            name: "",
            phone: "",
            type: ""
        });
    }

    const filterUser = () => {
        setUsers(userList.filter(u => u.id.includes(userForm.id)
            && u.name.toUpperCase().includes(userForm.name.toUpperCase())
            && u.profile.join(",").toUpperCase().includes(userForm.type.toUpperCase())
            && u.phone.includes(userForm.phone)));
    }

    const handleRequestForm = (e) => {
        let name = e.target.name;
        let value = e.target.value.trim();
        setRequestForm(pre => ({ ...pre, [name]: value }));
    }

    const resetRequestForm = () => {
        setRequestForm({
            type: "",
            name: "",
            user: "",
            userId: "",
            to: "",
            from: ""
        });
    };
    const filterRequest = () => {

        let from = new Date(requestForm.from);
        from.setHours("00", "00", "00");
        let to = new Date(requestForm.to);
        to.setHours("23", "59", "59");

        setRequestList(requests.filter(r => r.typeName.toUpperCase().includes(requestForm.type.toUpperCase())
            && r.name.toUpperCase().includes(requestForm.name.toUpperCase())
            && r.userId.includes(requestForm.userId)
            && (requestForm.from ? parseInt(r.reqId) >= new Date(from).getTime() : true)
            && (requestForm.to ? parseInt(r.reqId) <= new Date(to).getTime() : true)
            && (requestForm.user ? users.find(u => u.id === r.userId).name.toUpperCase()
                .includes(requestForm.user.toUpperCase()) : true)
        ));
    }


    return (
        <div className="col-lg-12">
            <PicModal details={modalDetails} />
            <div className="portfolio-info">
                <h3>
                    <div className="row">
                        <div className="col-8 col-sm-8">
                            <span>Admin </span>
                        </div>
                        <div className="col-4 col-sm-4 text-end">
                            {msgUser === "No data" || userList.length > 0 ?
                                <button className="btn btn-sm btn-success" disabled={msgConnect === "Loading" ? true : false}
                                    onClick={() => getUsers()}>Connected</button>
                                :
                                <button className="btn btn-sm btn-warning" disabled={msgConnect === "Loading" ? true : false}
                                    onClick={() => getUsers()}>Connect</button>
                            }
                        </div>
                    </div></h3>
                <div className="row">
                    <div className="col-12 col-sm-12 table-responsive">
                        <div>
                            <nav>
                                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                    <button className="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Home</button>
                                    <button className="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab"
                                        aria-controls="nav-contact" aria-selected="true">Emails
                                        <span className="badge bg-secondary mx-1">{emails.length}</span>
                                    </button>
                                    <button className="nav-link" id="nav-user-tab" data-bs-toggle="tab" data-bs-target="#nav-user" type="button" role="tab" aria-controls="nav-user" aria-selected="false">User
                                        <span className="badge bg-secondary mx-1">{userList.length}</span></button>
                                    <button className="nav-link" id="nav-request-tab" data-bs-toggle="tab" data-bs-target="#nav-request" type="button" role="tab" aria-controls="nav-request" aria-selected="false">Request
                                        <span className="badge bg-secondary mx-1">{requests.length}</span></button>
                                </div>
                            </nav>
                            <div className="tab-content" id="nav-tabContent">
                                <div className="tab-pane fade show active p-2 text-center" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                                    {userList.length > 0 || msgUser === "No data" ?
                                        <i className="h4">Connected with Admin</i>
                                        :
                                        msgConnect ?
                                            <i className="h4">{msgConnect}</i>
                                            :
                                            <i className="h4">Connect to Admin</i>
                                    }

                                </div>
                                <div className="tab-pane fade table-responsive" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                                    {msgEmails ? <div className="h4 text-center pt-2">{msgEmails}</div> :
                                        <table className="table table-striped table-sm">
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th>Time</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emails.sort((a, b) => b.time - a.time).map((e, i) => <React.Fragment key={i}><tr>
                                                    <td>{e.name}</td>
                                                    <td>{e.email}</td>
                                                    <td>{new Date(e.time).toLocaleString()}</td>
                                                </tr>
                                                    <tr>
                                                        <td colSpan="3">
                                                            <i className="h6">Subject: {e.subject}</i>
                                                            <p className="h6 mt-2">{e.message}</p>
                                                        </td>
                                                    </tr>
                                                </React.Fragment>
                                                )}
                                            </tbody>
                                        </table>}
                                </div>
                                <div className="tab-pane fade" id="nav-user" role="tabpanel" aria-labelledby="nav-user-tab">
                                    {msgUser ? <div className="h4 text-center pt-2">{msgUser ? msgUser : "No data"}</div> : <>
                                        <div className='row gy-2 mt-2'>
                                            <div className='col-6 col-sm-2'>
                                                <i className='h6'>Id:</i><input type="text" className='form-control form-control-sm' value={userForm.id}
                                                    placeholder='id' name="id" onChange={handleUserForm} />
                                            </div>
                                            <div className='col-6 col-sm-2'>
                                                <i className='h6'>Name:</i><input type="text" className='form-control form-control-sm' value={userForm.name}
                                                    placeholder='name' name="name" onChange={handleUserForm} />
                                            </div>
                                            <div className='col-6 col-sm-2'>
                                                <i className='h6'>Phone:</i><input type="text" className='form-control form-control-sm' value={userForm.phone}
                                                    placeholder='phone' name="phone" onChange={handleUserForm} />
                                            </div>
                                            <div className='col-6 col-sm-2'>
                                                <i className='h6'>Type:</i><input type="text" className='form-control form-control-sm' value={userForm.type}
                                                    placeholder='type' name="type" onChange={handleUserForm} />
                                            </div>
                                            <div className='col-6 col-sm-3' style={{ placeSelf: "end" }}>
                                                <button className='btn btn-sm btn-info mx-2' onClick={() => filterUser()}>Filter</button>
                                                <button className='btn btn-sm btn-secondary' onClick={() => resetUserForm()}>Reset</button>
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table table-striped table-sm mt-2">
                                                <thead>
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Phone</th>
                                                        <th>Profile</th>
                                                        <th>Pic</th>
                                                        <th>Email</th>
                                                        <th>Id</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {users.map((u, i) => <tr key={i}>
                                                        <td>{u.name}</td>
                                                        <td>{u.phone}</td>
                                                        <td>{u.profile.join(",")}</td>
                                                        <td><button className="btn btn-sm btn-secondary" data-bs-toggle="modal" data-bs-target="#picModal"
                                                            onClick={() => setModalDetails({ name: u.name, pic: u.pic })}>Pic</button></td>
                                                        <td>{u.email}</td>
                                                        <td>{u.id}</td>
                                                    </tr>)}
                                                </tbody>
                                            </table></div></>}
                                </div>
                                <div className="tab-pane fade" id="nav-request" role="tabpanel" aria-labelledby="nav-request-tab">
                                    {requests.length === 0 ? <div className="h4 text-center pt-2">No data</div> : <>
                                        <div className='row gy-2 mt-2'>
                                            <div className='col-6 col-sm-3'>
                                                <i className='h6'>Type:</i><input type="text" className='form-control form-control-sm' value={requestForm.type}
                                                    placeholder='type' name="type" onChange={handleRequestForm} />
                                            </div>
                                            <div className='col-6 col-sm-3'>
                                                <i className='h6'>Name:</i><input type="text" className='form-control form-control-sm' value={requestForm.name}
                                                    placeholder='name' name="name" onChange={handleRequestForm} />
                                            </div>
                                            <div className='col-6 col-sm-3'>
                                                <i className='h6'>User:</i><input type="text" className='form-control form-control-sm' value={requestForm.user}
                                                    placeholder='user' name="user" onChange={handleRequestForm} />
                                            </div>
                                            <div className='col-6 col-sm-3'>
                                                <i className='h6'>UserId:</i><input type="text" className='form-control form-control-sm' value={requestForm.userId}
                                                    placeholder='userId' name="userId" onChange={handleRequestForm} />
                                            </div>
                                            <div className='col-6 col-sm-3'>
                                                <i className='h6'>From:</i> <input type="date" className='form-control form-control-sm' value={requestForm.from}
                                                    name="from" onChange={handleRequestForm} />
                                            </div>
                                            <div className='col-6 col-sm-3'>
                                                <i className='h6'>To:</i><input type="date" className='form-control form-control-sm' value={requestForm.to}
                                                    name="to" onChange={handleRequestForm} />
                                            </div>
                                            <div className='col-6 col-sm-3' style={{ placeSelf: "end" }}>
                                                <button className='btn btn-sm btn-info mx-2' onClick={() => filterRequest()}>Filter</button>
                                                <button className='btn btn-sm btn-secondary' onClick={() => resetRequestForm()}>Reset</button>
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table table-striped table-sm mt-2">
                                                <thead>
                                                    <tr>
                                                        <th>Type</th>
                                                        <th>Name</th>
                                                        <th>Contact</th>
                                                        <th>Time</th>
                                                        <th>User</th>
                                                        <th>User phone</th>
                                                        <th>TypeId</th>
                                                        <th>User Id</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {requestList.map((r, i) => <tr key={i}>
                                                        <td>{r.typeName}</td>
                                                        <td>{r.name}</td>
                                                        <td>{r.contact}</td>
                                                        <td>{new Date(parseInt(r.reqId)).toLocaleString()}</td>
                                                        <td>{userList.find(u => u.id === r.userId).name}</td>
                                                        <td>{userList.find(u => u.id === r.userId).phone}</td>
                                                        <td>{r.typeId}</td>
                                                        <td>{r.userId}</td>
                                                    </tr>)}
                                                </tbody>
                                            </table></div></>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
